import { core_v1_DataSource } from '@antimatterhq/asl-api-ts-v1';
import { produce } from 'immer';
import { SourceSchemaFormValues } from '@/zod/schemas/dataSource/Source';

export const getSourceInitialValues = (
  dataSource: core_v1_DataSource,
): SourceSchemaFormValues => {
  const source = dataSource.spec.source || '';
  const sourceType = dataSource.spec.sourceType || '';
  const usePreset = dataSource.spec.usePreset || '';

  return { source, sourceType, usePreset };
};

export const getIsSourceCompleted = (
  dataSource: core_v1_DataSource,
): boolean => {
  return !!dataSource.spec.source && !!dataSource.spec.sourceType;
};

export const setSourceFormValues = (
  dataSource: core_v1_DataSource,
  values: SourceSchemaFormValues,
): core_v1_DataSource => {
  return produce(dataSource, (draftState) => ({
    ...draftState,
    spec: {
      ...draftState.spec,
      source: values.source,
      sourceType: values.sourceType,
      usePreset: values.usePreset || undefined,
    },
  }));
};

export const sourceHasUnsavedChanges = (
  datasource: core_v1_DataSource,
  unsavedDatasource: core_v1_DataSource | undefined,
) => {
  if (!unsavedDatasource) {
    return false;
  }
  return (
    datasource.spec.source !== unsavedDatasource.spec.source ||
    datasource.spec.sourceType !== unsavedDatasource.spec.sourceType
  );
};
